export default __webpack_public_path__ + "static/media/spacecowboy.f9dde802.png";